import { SortDefinition } from '../../shared/models/sort-definition';

export interface CartographieState {
  paginator: { pageNb: number; pageSize: number };
  sort: SortDefinition;
}

export const initialState: CartographieState = {
  paginator: { pageNb: 1, pageSize: 20 },
  sort: { direction: '+', nom: 'nom' },
};
